import React from "react";
import { useSpring, animated } from '@react-spring/web';
import logo from '/imageAssets/pfizer-logo-color.png';

export default function Header({
    setIsMenuActive, 
    isMenuActive,
    startExperience,
    shouldAnimate,
    isModelLoaded
}) {
    const logoSpring = useSpring({
        opacity: shouldAnimate || !isModelLoaded ? 0 : 1,
        transform: shouldAnimate || !isModelLoaded ? 'translateY(-100%)' : 'translateY(0%)',
        config: { tension: 280, friction: 60 },
        position: 'absolute',
        width: '120px'
    });

    const menuSpring = useSpring({
        opacity: startExperience ? 1 : 0,
        transform: startExperience ? 'translateY(0%)' : 'translateY(-100%)',
        config: { tension: 280, friction: 60 }
    });

    return (
        <div className="header">
            <animated.img 
                src={logo} 
                alt="Logo" 
                className="logo"
                style={logoSpring}
            />
            <animated.div 
                style={menuSpring}
                className={`burger-menu ${isMenuActive ? 'active-menu' : ''}`} 
                onClick={() => startExperience && setIsMenuActive(prevState => !prevState)}
            >
                <div className="burger-menu-inner">
                    <svg className="svg-line-left" width="23" height="3" viewBox="0 0 23 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.0258789 1.63599H22.7259" stroke="white" strokeWidth="2"/>
                    </svg>
                    <svg className="svg-line-right" width="23" height="3" viewBox="0 0 23 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.0258789 1.63599H22.7259" stroke="white" strokeWidth="2"/>
                    </svg>
                </div>
            </animated.div>
        </div>
    )
}